<template>
    <div class="security-modal-component">
      <div class="security-icon" @click="openModal">
        <img src="@/assets/security.svg" :alt="$t('security.modal.icon_alt')" />
      </div> 
      <div v-if="showModal" class="modal-overlay" @click="handleOverlayClick">
        <div ref="modalContent" class="modal-content" :style="modalStyle" @click.stop>
          <div class="close-div">
            <button class="close-button" @click="closeModal">X</button>
          </div>
          <p class="title">{{ $t('security.modal.title') }}</p>

          <p>{{ $t('security.modal.subtitle') }}</p>
          <p style="color: #cca971; font-weight: 500;">{{ $t('security.modal.intro_encryption') }}
            <br>{{ $t('security.modal.intro_keyless') }} <br>
        <br> </p>
        <div class="encryption-flow">
             <div class="flow-item">
               <div class="box">{{ $t('security.modal.flow.user_password') }}</div>
               <div class="arrow">→</div>
             </div>
             <div class="flow-item">
               <div class="box">{{ $t('security.modal.flow.key_derivation') }}<br />{{ $t('security.modal.flow.key_derivation_sub') }}</div>
               <div class="arrow">→</div>
             </div>
             <div class="flow-item">
               <div class="box">{{ $t('security.modal.flow.aes_key') }}</div>
               <div class="arrow">→</div>
             </div>
             <div class="flow-item">
               <div class="box">{{ $t('security.modal.flow.aes_encryption') }}</div>
               <div class="arrow">→</div>
             </div>
             <div class="flow-item">
               <div class="box">{{ $t('security.modal.flow.encrypted_db') }}</div>
             </div>
           </div>
           <p style="color: #cca971; font-weight: 500;"><b>{{ $t('security.modal.warning_label') }}</b> {{ $t('security.modal.warning_body') }}
            <br><br>{{ $t('security.modal.warning_link_before') }} <router-link to="/sozlesmeler" style="color: #cca971; font-weight: 500;">{{ $t('security.modal.warning_link_text') }}</router-link>{{ $t('security.modal.warning_link_after') }}
                     
                     
          </p>
            <p>{{ $t('security.modal.password_advice') }} <br>{{ $t('security.modal.two_fa_advice_line1') }} <br>{{ $t('security.modal.two_fa_advice_line2') }}
            </p>
   
           
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.kvkk.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.kvkk.description') }}
             </p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.gdpr.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.gdpr.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.ssl.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.ssl.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.aes.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.aes.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.waf.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.waf.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.two_fa.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.two_fa.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.pentest.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.pentest.description') }}</p>
          </div> 
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.dlp.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.dlp.description') }}</p>
          </div>
          <div class="security-item">
            <h4 class="title">{{ $t('security.modal.items.owasp.title') }}<img src="@/assets/icon/application/ok.svg" :alt="$t('security.modal.active_alt')" /></h4>
            <p>{{ $t('security.modal.items.owasp.description') }}</p>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, nextTick } from "vue";
  
  export default {
    setup() {
      const showModal = ref(false);
      const modalStyle = ref({
        transform: "translateY(100%)",
        transition: "transform 0.3s ease-in-out",
      });
  
      const openModal = () => {
        showModal.value = true;
        nextTick(() => {
          setTimeout(() => {
            modalStyle.value.transform = "translateY(0)";
          }, 10);
        });
      };
  
      const closeModal = () => {
        modalStyle.value.transform = "translateY(100%)";
        setTimeout(() => {
          showModal.value = false;
        }, 400);
      };
  
      const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
          closeModal();
        }
      };
  
      return {
        showModal,
        modalStyle,
        openModal,
        closeModal,
        handleOverlayClick,
      };
    }
  };
  </script>

  <style scoped>
  .security-modal-component {
    margin-top: 5rem;
    display: flex;
    justify-content: center;
    align-items: center; 
  }
  .security-icon {
    cursor: pointer; 
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }
  .security-icon:hover {
    transform: scale(1.1);
  }
  .security-icon img {
    width: 5rem;
    height: 5rem;
    opacity: 0.5;
  }
  .security-icon img:hover {
    width: 5rem;
    height: 5rem;
    opacity: 1;
  }
  
  /* Modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 9999;
  }
  
  .modal-content { 
    width: 100%;
    max-width: 680px;
    background: linear-gradient(45deg, #020202, #030b0b, #050505);
    border-radius: 10px 10px 0 0;
    border-top: 1px solid #022121;
    border-left: 1px solid #022121;
    border-right: 1px solid #022121;
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.5);
    padding: 1rem;
    overflow-y: auto;
    max-height: 70vh;
    min-height: 60vh;
  }
  
  .close-div {
    position: sticky;
    border-radius: 15px 15px 0 0;
    top: 0;
    display: flex;
    justify-content: flex-end;
    z-index: 1;
    padding: 0.5rem;
  }
  
  .close-button {
    background-color: #000000;
    color: #ffffff;
    padding: 0.8rem;
    min-width: 3rem;
    max-width: 3rem;
    border-radius: 2rem;
    opacity: 0.8;
    border: 1px solid #444444;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
   
  .close-button:hover {
    opacity: 1;
    transform: scale(1.1);
  }
   
  @media (max-width: 768px) {
    .modal-content {
      max-width: 90%;
    }
  }
  

.security-item h4 {
  color: #106e35;
  margin-bottom: 0.3rem;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  font-weight: 500;
}
.security-item h4 img{
  height: 0.7em; margin-left: 5px; opacity: 0.7;
}

.security-item p { 
  line-height: 1.4;
}



.encryption-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 2rem 0;
}

.flow-item {
  display: flex;
  align-items: center;
}

.box { 
  border: 1px solid #6e5d41;
  padding: 1em;
  min-width: 6rem;
  text-align: center;
  border-radius: 10px;
  color: #cec8bf; 
  transition: transform 0.3s ease;
}

.box:hover {
  transform: translateY(-3px);
}

.arrow {
  color: #cca971;
  font-size: 1.5rem;
  margin: 0 0.3rem;
}


  </style>